import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Place } from '@/types/place';
import LocationMapPigeon2 from './LocationMapPigeon2';
import { useUiStore } from '@/stores/uiStore';

interface PlaceMapProps {
  place: Place;
  height?: string;
}

/**
 * Place map component displaying place location.
 */
export const PlaceMap: React.FC<PlaceMapProps> = ({ place, height = '40vh' }) => {
  const setMapCenter = useUiStore((state) => state.setMapCenter);
  
  // Get coordinates from place (handles both structure formats)
  const coordinates = place.coordinates || 
    (place.latitude && place.longitude 
      ? { latitude: place.latitude, longitude: place.longitude }
      : null);

  // Center map on place location when component mounts or place changes
  useEffect(() => {
    if (coordinates) {
      setMapCenter([coordinates.latitude, coordinates.longitude]);
    }
  }, [place, setMapCenter]);

  if (!coordinates) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <LocationMapPigeon2
        places={[place]}
        center={[coordinates.latitude, coordinates.longitude]}
        height={height}
        showOverlayCard={false}
      />
    </Box>
  );
};
